<template>
  <div class="header">
    <div class="header-box clearfix">
      <div class="header-lt fl" style="width: 201px;">
        <img src="../../assets/images/daohang.png"
             alt="">
        <span>导航</span>
        <div class="float-window">
          <el-menu 
              @select="handleSelect"
              :default-openeds="['0']"
              class="el-menu-vertical-demo">
              <el-submenu :index="''+i" v-for="(t,i) in menus" :key="t.id">
                <template slot="title">
                  <i class="el-icon-document"></i>
                  <span>{{t.name}}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item :class="[(i+'_'+ x) == active? 'activeClass':'']"  v-for="(n,x) in t.child" :key="n.id" 
                  :index="i+'_'+ x">
                    <router-link :to="n.route" v-if="n.cid == null">
                      {{n.name}}
                    </router-link>
                    <router-link :to="{name:'museumlist',query:{cid:n.cid,name:n.name}}"    v-else-if="n.cid == 1 || n.cid == 2">
                      {{n.name}}
                    </router-link>
                    <router-link :to="{name:'newairmuseumlist',query:{cid:n.cid,name:n.name}}" v-else-if="n.cid == 3 ">{{n.name}}</router-link>
                    <router-link v-else-if="n.cid == 4 " :to="{name:'equipmuseumlist',query:{cid:n.cid,name:n.name}}" v-else>{{n.name}}</router-link>
                    <router-link v-else :to="{name:'equitlist',query:{cid:n.cid,name:n.name}}">{{n.name}}</router-link>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
        </div>
      </div>


      <div class="header-logo">
        <router-link to="/">
          <img src="../../assets/images/logo.png"
               alt="">
        </router-link>
      </div>
      <div class="header-rt1 fr">

        <el-button @click="gotoC"
                   v-if="admin ===1">
          返回前台展示
        </el-button>
        <span class="nickname">{{username||'管理员'}}</span>
        <span class="out"
              @click="open">修改密码</span>
        <span class="out"
              @click="out">退出</span>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: 'hd',
  data: () => ({
    isLogin: true,
    admin: 0,
    menus:[],
    username: '',
    options: [],
    value: '',
    list: [],
    active:'0_0'
  }),
  //      函数放置
  methods: {
    men (value) {
      this.$router.push({
        path: '/list',
        query: {
          m_type: value + 1
        }
      })
    },

    //修改密码
    resetpw(params){
      this.$http.post(this.$store.state.api + '/user/setpw.html',params).then((res) => {
        if(res.data.code == 200 ){
          this.$message.success('密码修改成功')
        }
      }).catch(function (err) {
        console.log(error)
      });
    },

    //修改密码
    open() {
        this.$prompt('请输入新密码', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.{5,19}/,
          inputType:'password',
          inputErrorMessage: '密码格式不正确，请重新输入'
        }).then(({ value }) => {
          let token = localStorage.getItem('token')
          this.resetpw({pw:value,token:token})

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      },

    gotoC () {
      this.$router.push('/')
    },
    initUserInfo () {
      let userInfo = JSON.parse(localStorage.getItem(
        'user__info',
      )) || {};
      this.admin = userInfo.is_admin
      this.username = userInfo.username
      // {"is_admin":1,"nickname":null}
    },

    out () {
      localStorage.removeItem('token');
      // this.isLogin = false;
        this.$store.commit('isLoginDate',false)
      if (this.$route.query.activity == '1') {
        return false;
      }
      this.$router.push({
        path: '/system/login',
      })
    },

    getMenus(token_value){
        this.$http.get(this.$store.state.api + '/menu/list.html?token=' +token_value).then((res) => {
              if(res.data.code == 200){
                  this.menus = res.data.data;
              }
            }).catch(function (err) {
              console.log(err);
            })
    },

    handleSelect(key,keypath){
      this.active = key
    }


  },
  //     dom挂载之后
  mounted () {
    this.$nextTick(() => {

      if (this.$route.name == 'searchone' || this.$route.name == 'searchtwo') {
        this.value = this.$route.query.type;
      }

    })
    this.initUserInfo()
  },
  //    dom挂载之前
  created () {

    let token = localStorage.getItem('token');
    this.getMenus(token);


  },
  //    组件
  components: {},
  //    计算函数
  computed: {}
}
</script>
<style lang="scss" type="text/scss">
@import "../../style/css/helpers/mixin";
.header {
  background-color: #fffdfd;
  height: 70px;
  line-height: 70px;
  width: 100%;
  border-bottom: 1px solid #ebe6e6;
  .header-box {
    width: 100%;
    position: relative;
    .header-lt {
      position: relative;
      text-align: center;
      cursor: pointer;
      border-right: 1px solid #ebe6e6;
      img {
        width: 16px;
        height: 14px;
      }
      span {
        font-size: 16px;
        color: #212020;
      }
      .float-window {
        display: none;
        cursor: pointer;
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        z-index: 2;
        background: #fffdfd;
        line-height: 48px;
        div {
          padding-left: 0px;
        }
        div:hover {
          background: #f5f7fa;
          color: #fec8c9;
        }
      }
    }
    .header-lt:hover {
      .float-window {
        display: block;
      }
    }

    .header-logo {
      img {
        @include absoluteCenter();
        /*width: 123px;*/
        height: 42px;
        cursor: pointer;
      }
    }
    .header-rt {
      width: 190px;
      height: 70px;
      text-align: center;
      background: #fec8c9;
      color: #fff;
      a {
        color: #fff;
        &:hover {
          color: #000;
        }
      }
    }
    .header-rt1 {
      width: 330px;
      height: 70px;
      text-align: center;
      @include userSelect;
      .el-button {
        margin-right: 20px;
        border-color: #555;
      }
      .nickname {
        font-size: 17px;
        color: #313131;
        cursor: pointer;
      }
      .out {
        font-size: 12px;
        color: #777;
        cursor: pointer;
      }
    }
  }
}
/*.fenlei .el-select .el-input.is-focus .el-input__inner{*/

.fenlei {
  height: 70px;
  margin-left: 20px;
  box-sizing: border-box;
  .el-select .el-input {
    .el-input__inner {
      width: 100px;
      border: 1px solid #555;
      color: #000;
    }
    .el-select__caret {
      color: #000;
    }
  }
}
.el-menu-item{
  a{
    width:100%;
    height:100%;
    display:block;
  }
} 
.activeClass{
  background: #f5f7fa;
}
.activeClass a{
  color:#fec8c9
}

</style>



// WEBPACK FOOTER //
// src/components/header/header-back.vue